
import Footer from './Footer/Footer';
import Navbar from './Navbar/Navbar';


function Layout({children}) {

  return (
    <>
    <Navbar/>
    <div className='dark:bg-[rgba(0,0,0)]'>
  <div >
  {children}
  </div>
  </div>
  <Footer/>
  </>
  );
}

export default Layout;
